export default __webpack_public_path__ + "static/media/jazzDrive.f36cc728.svg";